import { render, staticRenderFns } from "./UploadPanel.vue?vue&type=template&id=05bf6f7f&scoped=true"
import script from "./UploadPanel.vue?vue&type=script&lang=js"
export * from "./UploadPanel.vue?vue&type=script&lang=js"
import style0 from "./UploadPanel.vue?vue&type=style&index=0&id=05bf6f7f&prod&lang=scss&scoped=true"
import style1 from "./UploadPanel.vue?vue&type=style&index=1&id=05bf6f7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf6f7f",
  null
  
)

export default component.exports